import React from 'react';

import { IRouter } from '@routers/interface';

export const routerDeviceDashboardOrganizations: IRouter = {
  path: '/dashboard/organizations/:organizationId/device-dashboard',
  loader: React.lazy(() => import('./index')),
  activePath: '/dashboard',
  exact: true,
  name: 'Dashboard', //translate here for breadcrumb and sidebar
  masterLayout: true,
  nameBreadcrumb: 'dashboard.device.router.nameBreadcrumb',
  generatePath(organizationId) {
    return `/dashboard/organizations/${organizationId}/device-dashboard`;
  },
};

export const routerDeviceDashboard: IRouter = {
  path: '/dashboard/device-dashboard',
  loader: React.lazy(() => import('./index')),
  activePath: '/dashboard',
  exact: true,
  name: 'Dashboard', //translate here for breadcrumb and sidebar
  masterLayout: true,
  nameBreadcrumb: 'dashboard.device.router.nameBreadcrumb',
};

export const routerScreenshotsHistoryOrganizations: IRouter = {
  path: '/dashboard/organizations/:organizationId/device-dashboard/:facilityId/screenshot-history/:id/:hisType',
  loader: React.lazy(() => import('./components/ScreenshotHistory')),
  activePath: '/dashboard',
  exact: true,
  name: 'Dashboard', //translate here for breadcrumb and sidebar
  masterLayout: true,
  nameBreadcrumb: 'dashboard.device.screenshots.history.router.nameBreadcrumb',
  generatePath(organizationId, facilityId) {
    return `/dashboard/organizations/${organizationId}/device-dashboard/${facilityId}/screenshot-history/:id/:hisType`;
  },
};

export const routerScreenshotsHistory: IRouter = {
  path: '/dashboard/device-dashboard/:facilityId/screenshot-history/:id/:hisType',
  loader: React.lazy(() => import('./components/ScreenshotHistory')),
  activePath: '/dashboard',
  exact: true,
  name: 'Dashboard', //translate here for breadcrumb and sidebar
  masterLayout: true,
  nameBreadcrumb: 'dashboard.device.screenshots.history.router.nameBreadcrumb',
};
